import type { TooltipProps } from "@radix-ui/react-tooltip";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { Children, type PropsWithChildren, type ReactNode } from "react";
import { cn } from "@/utils/style.ts";

type Props = PropsWithChildren<{ trigger: ReactNode }>;
export default function TooltipComponent({ children, trigger }: Props) {
    return (
        <Tooltip>
            <TooltipTrigger>{trigger}</TooltipTrigger>
            <TooltipContent>{children}</TooltipContent>
        </Tooltip>
    );
}

export function Tooltip(props: PropsWithChildren<TooltipProps>) {
    return (
        <TooltipPrimitive.Provider delayDuration={300}>
            <TooltipPrimitive.Root {...props} />
        </TooltipPrimitive.Provider>
    );
}

export function TooltipTrigger({ children }: PropsWithChildren) {
    return <TooltipPrimitive.Trigger asChild={Children.count(children) === 1}>{children}</TooltipPrimitive.Trigger>;
}

export function TooltipContent({ children, className, ...props }: TooltipPrimitive.TooltipContentProps) {
    return (
        <TooltipPrimitive.Content
            side="right"
            align="center"
            sideOffset={8}
            {...props}
            className={cn("tooltip", className)}
        >
            {children}
            <TooltipPrimitive.Arrow className="tooltip__arrow" />
        </TooltipPrimitive.Content>
    );
}
